
@if (display) {
  <div style="border: solid 1px #888; border-radius: 3px; position: absolute; bottom: 10px; left: 10px; right: 10px; padding: 5px; backdrop-filter: blur(10px); background-color: var(--cds--alias-object-app-background);">
  <!-- What the view puts above its legend, the apps group selected on the apps groups map for instance -->
  <ng-content></ng-content>
  <span>
    <!-- Legend for resources -->
    @if (selectedView == "clusters-viewer"){
      <!-- Infrastructure nodes -->
      <span style="margin-top: 5px; height: 15px; width: 15px; border-radius: 50%; display: inline-block; border: solid 5px #007FCB">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Infrastructure</span>
      <!-- External IPs -->
      <span style="margin-top: 5px; height: 15px; width: 15px; border-radius: 50%; display: inline-block; border: solid 5px #a0b3b3">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">External IPs</span>
      <!-- Unknown IPs -->
      <span style="margin-top: 5px; height: 15px; width: 15px; border-radius: 50%; display: inline-block; border: solid 5px #a620e3">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Unknown IPs</span>
      <!-- Internet IPs -->
      <span style="margin-top: 5px; height: 15px; width: 15px; border-radius: 50%; display: inline-block; border: solid 5px #d91919">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Internet IPs</span>
      <!-- Focused resources -->
      <span style="margin-top: 5px; height: 15px; width: 15px; border-radius: 50%; display: inline-block; border: solid 5px #e79807">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Focused resources</span>
    }
    @if (selectedView == "apps-groups"){
      <!-- Infrastructure nodes -->
      <span style="margin-top: 5px; height: 15px; width: 15px; background-color: rgba(195,201,213,0.8); border-radius: 0%; display: inline-block; border: solid 2px #5b6dae">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">App group</span>
      <!-- Focused resources -->
      <span style="margin-top: 5px; height: 15px; width: 15px; background-color: rgba(80,216,248,0.53); border-radius: 50%; display: inline-block; border: solid 2px #5b6dae">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Virtual machines</span>
    }
    @if (selectedView == "dependencies-viewer"){
      <!-- Hypervisors -->
      <span style="position: relative; top: -3px; height: 5px; width: 20px; background-color: rgb(134, 56, 155); display: inline-block;">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Hypervisors</span>
      <!-- Infrastructure nodes -->
      <span style="margin-top: 5px; height: 15px; width: 15px; background-color: #FFF; border-radius: 50%; display: inline-block; border: solid 5px #007FCB">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">VMs</span>
      <!-- Focused resources -->
      <span style="margin-top: 5px; height: 15px; width: 15px; background-color: #FFF; border-radius: 50%; display: inline-block; border: solid 5px #e79807">
      </span> <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Focused resources</span>
    }
    @if (selectedView == "protocol-analysis"){
      <!-- Protocol nodes -->
      <span style="margin-top: 5px; height: 15px; width: 15px; background-color: rgba(105, 209, 185, 1); border-radius: 50%; display: inline-block; border: solid 5px rgba(105, 209, 185, 1)">
      </span>
      <span style="position: relative; bottom: 1px; margin-left: 5px; margin-top: 2px; height: 12px; width: 12px; background-color: rgba(105, 209, 185, 1); border-radius: 50%; display: inline-block; border: solid 5px rgba(105, 209, 185, 1)">
      </span>
      <span style="position: relative; bottom: 2px; margin-left: 5px; margin-top: 0px; height: 8px; width: 8px; background-color: rgba(105, 209, 185, 1); border-radius: 50%; display: inline-block; border: solid 5px rgba(105, 209, 185, 1)">
      </span>
      <span style="position: relative; top: -2px; font-size: 12px; margin-left: 5px; margin-right: 5px;">Protocols</span>
    }

    <!-- Gradient legend bar that shows volumetry -->
    @if (selectedView == "clusters-viewer"){
      <table style="float: right;">
        <tr style="height: 5px;">
          @for (gradientItem of gradient; track gradientItem) {
            <td style="margin-left: 5px; min-width: 100px; background-color: {{ gradientItem.color }}"></td>
          }
        </tr>
        <tr>
          @for (gradientItem of gradient; track gradientItem) {
            <td style="font-size: 12px;">{{gradientItem.volumetryLabel}}</td>
          }
        </tr>
      </table>
    }
  </span>

  </div>

}

